import script from "./ProductImageZoom.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductImageZoom.vue?vue&type=script&lang=ts&setup=true"

import "./ProductImageZoom.vue?vue&type=style&index=0&id=28ea6d5e&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ea6d5e"]])

export default __exports__